import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Observable, of, switchMap, take } from 'rxjs';
import { Role } from '../../entities/role/role';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';

/**
 * Roles service.
 */
@Injectable()
export class RolesService {
  constructor(
    protected keycloakAngular: KeycloakService,
    private apolloService: ApolloService) {}

  /**
   *
   * @param role
   * return Boolean hasRole
   */
  public hasRole(role: string): boolean {
    const roles = this.keycloakAngular.getKeycloakInstance()
      ? this.keycloakAngular.getKeycloakInstance().realmAccess?.roles
      : [];
    return roles ? roles.some((x) => x === role) : false;
  }

  public getRoles(): Observable<Role[]> {
    return this.apolloService.query<fromGraphQl.GetRolesResponse>(fromGraphQl.GET_ROLES_QUERY)
      .pipe(
        take(1),
        switchMap( (result) => {
          return of( Role.createRoles(result.data.getRoles));
        })
      );
  }

}
